import { render, staticRenderFns } from "./ModuleEditor.vue?vue&type=template&id=1cb0158c&"
import script from "./ModuleEditor.vue?vue&type=script&lang=js&"
export * from "./ModuleEditor.vue?vue&type=script&lang=js&"
import style0 from "./ModuleEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports